import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Video } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import { useNextClass, classTimerLabel, liveClassTarget } from '../../lib/nextClass';

/** Bottom-tab "My Class": the next class as a mini timer badge; red LIVE while it runs (tap → straight into the room). */
export function MyClassTab({ className, activeClass, idleClass }) {
  const { user } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const ev = useNextClass(user?.id);
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => { const t = setInterval(() => setNow(Date.now()), 30_000); return () => clearInterval(t); }, []);
  const { label, state } = classTimerLabel(ev, now);
  const active = location.pathname.startsWith('/group-classes') || location.pathname.startsWith('/live/');
  const live = state === 'live';
  const onClick = (e) => {
    if (!live) return;
    const t = liveClassTarget(ev);
    if (t.href) { e.preventDefault(); window.open(t.href, '_blank', 'noopener,noreferrer'); }
    else if (t.to !== '/group-classes') { e.preventDefault(); navigate(t.to); }
  };
  return (
    <Link to="/group-classes" onClick={onClick} data-testid="bottom-nav-my-class" data-state={state}
      className={`${className} ${active || live ? activeClass : idleClass} ${live ? '!text-rose-600' : ''}`}>
      <span className={`relative px-3 py-0.5 rounded-full transition-colors ${active ? 'bg-blue-50' : ''}`}>
        <Video size={20} />
        {label && (
          <span className={`absolute -top-1 -right-1.5 whitespace-nowrap rounded-full px-1.5 py-[1px] text-[9px] font-extrabold leading-tight tabular-nums shadow-sm ring-2 ring-white ${live ? 'bg-rose-600 text-white animate-pulse' : state === 'soon' ? 'bg-emerald-600 text-white' : 'bg-slate-900 text-white'}`}
            data-testid="bottom-nav-my-class-timer">{label}</span>
        )}
      </span>
      Class
    </Link>
  );
}
